import { CryptoAsset } from '@/shared/modules/wallet/use-crypto-assets';

import { SendFlow } from './send-flow';

interface SendModalProps {
  open: boolean;
  onClose: () => void;
  assets: CryptoAsset[];
  senderAddress: string | undefined;
  initialCoin?: CryptoAsset;
}

export const SendModal = (props: SendModalProps) => <SendFlow presentation="modal" {...props} />;
